var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('transition',[_c('router-view')],1),_c('ErrorMessage'),_c('ToastMessage'),_c('TokenErrorMessage'),_c('GlobalHeaderDrawer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }